export default "__VITE_ASSET__CqArrUPj__"